import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import '../scss/guess-card.scss';
import Color from '@tool/color';
import { CloseIcon20, ArrowDown, DownIcon, UpIcon } from '@styled/icon';
import { newRate, locateValue } from '@tool/index';
import moSalary from '../store/salary';
import moUser from '@store/user';

interface IProps {}
interface IState {}

const GuessCard = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { guessList, guessOverview, guessRecent } = moSalary;
  const { industry, city } = moUser;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <>
      <section className="card-1100">
        <p className="line-5500 line-5501">
          <b className="bold-11">{industry.name}行业</b>
          <span className="span-11">平均年薪</span>
        </p>
        <p className="line-5500 line-5502">
          <strong className="mont-font">{locateValue(guessOverview?.industry_salary)}</strong>
          <span className="span-15">/元</span>
        </p>
        <p className="line-5500 line-5503">
          {/* <DownIcon color={Color.success} />
          <UpIcon color={Color.red} /> */}
          {/* <b className="mont-font bold-13">3.9%</b> */}
          <span className="span-13">行业近12个月的数据</span>
        </p>
      </section>
      <section className="card-1100">
        <p className="line-5500 line-5501">
          <b className="bold-11">{city.name}地区</b>
          <span className="span-11">平均年薪</span>
        </p>
        <p className="line-5500 line-5502">
          <strong className="mont-font">{locateValue(guessOverview?.city_salary)}</strong>
          <span className="span-15">/元</span>
        </p>
        <p className="line-5500 line-5503">
          {/* <DownIcon color={Color.success} />
          <UpIcon color={Color.red} /> */}
          {/* <b className="mont-font bold-13">3.9%</b> */}
          <span className="span-13">行业+城市近12个月的数据</span>
        </p>
      </section>
      <section className="card-1100">
        <p className="line-5500 line-5501">
          <span className="span-11">公司在行业内的薪酬竞争力</span>
        </p>
        <p className="line-5500 line-5502">
          <strong className="mont-font">{locateValue(guessOverview?.company_rank)}</strong>
          <span className="span-15">所处分位</span>
        </p>
        <p className="line-5500 line-5503">
          <span className="span-13"
            style={{ marginLeft: 0 }}>基于公司的公开招聘信息预估
          </span>
        </p>
      </section>
      <section className="card-1100 card-1105">
        <p className="line-5500 line-5501">
          <span className="span-11">职位异动</span>
        </p>
        <section className="line-5500 line-5502 line-5505">
          <p className="line-5506">
            <span className="rise-11">招聘量大幅上涨 {guessOverview?.job_change?.amount_increase_count}</span>
            <span className="rise-11">薪酬大幅上涨 {guessOverview?.job_change?.salary_increase_count}</span>
          </p>
          <p className="line-5506">
            <span className="down-11">招聘量大幅下跌 {guessOverview?.job_change?.amount_decline_count}</span>
            <span className="down-11">薪酬大幅下跌 {guessOverview?.job_change?.salary_decline_count}</span>
          </p>
        </section>
        <p className="line-5500 line-5503"
          style={{ marginTop: 0 }}>
          <span className="span-13"
            style={{ marginLeft: 0 }}>{guessRecent} {guessOverview?.job_change?.change_job_count} 个岗位的数据大幅变动
          </span>
        </p>
      </section>
    </>
  );
};

export default observer(GuessCard);
